import { createElement } from "@max/max";
import Text from "@hfe/max-text";
import View from "@hfe/max-view";
import LinearGradient from '@hfe/max-linear-gradient';
import './index.scss';
export default function ModalBottomBtn(props) {
    const { buttonText, onPress } = props;
    if (!buttonText) {
        return null;
    }
    return <View onClick={onPress}>
        <LinearGradient start={{
        x: 0,
        y: 0
    }} end={{
        x: 1,
        y: 0
    }} colors={['#FFE74D', '#FFDD00']} className='modal-bottom-button'>
            <Text className="modal-bottom-button-text">{buttonText}</Text>
        </LinearGradient>
    </View>;
}
